import { SVGProps } from 'react';

const Manufacturing = ({
  props,
  fill = 'currentColor',
  size = 24,
}: {
  props?: SVGProps<SVGSVGElement>;
  fill?: string;
  size?: string | number;
}) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fill={fill}
      d="M19.5 14.25a3.25 3.25 0 0 1 0 6.5h-15a3.25 3.25 0 0 1 0-6.5h15Zm-15 1.5a1.75 1.75 0 1 0 0 3.5h15a1.75 1.75 0 1 0 0-3.5h-15Zm14-12.5A2.75 2.75 0 0 1 21.25 6v4.5a2.75 2.75 0 0 1-2.75 2.75H14a2.75 2.75 0 0 1-2.75-2.75V6A2.75 2.75 0 0 1 14 3.25h4.5ZM14 4.75c-.69 0-1.25.56-1.25 1.25v4.5c0 .69.56 1.25 1.25 1.25h4.5c.69 0 1.25-.56 1.25-1.25V6c0-.69-.56-1.25-1.25-1.25H14Zm-5.5 4.5a.75.75 0 0 1 0 1.5h-5a.75.75 0 0 1 0-1.5h5Zm0-3a.75.75 0 0 1 0 1.5h-3a.75.75 0 0 1 0-1.5h3Zm9.5 0a.75.75 0 0 1 0 1.5h-3.5a.75.75 0 0 1 0-1.5H18Z"
    />
  </svg>
);

export default Manufacturing;
